import {
  format,
  isSameYear,
  fromUnixTime,
  formatDistanceToNow,
} from 'date-fns';

import { ptBR } from 'date-fns/locale';

export default {
  methods: {
    messageStamp(time, dateFormat = 'HH:mm') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat, { locale: ptBR });
    },
    messageTimestamp(time, dateFormat = 'MMM d, yyyy') {
      const messageTime = fromUnixTime(time);
      const now = new Date();
      const messageDate = format(messageTime, dateFormat, { locale: ptBR });
      if (!isSameYear(messageTime, now)) {
        return format(messageTime, 'LLL d y, HH:mm', { locale: ptBR });
      }
      return messageDate;
    },
    dynamicTime(time) {
      const unixTime = fromUnixTime(time);
      return formatDistanceToNow(unixTime, { addSuffix: true, locale: ptBR });
    },
    dateFormat(time, dateFormat = 'MMM d, yyyy') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat, { locale: ptBR });
    },
    shortTimestamp(time) {
      const convertToShortTime = time
      .replace(/cerca de|mais de|quase|/g, '')
      .replace('menos de um minuto', 'agora')
      .replace('há', '')
      .replace('em ', '')
      return convertToShortTime.trim();
    },
  },
};
